<aside class="app-sidebar !bg-[#02578E]" id="sidebar" [ngClass]="{ 'sticky-pin': scrolled }">

  <!-- Start::main-sidebar-header -->
  <div class=" heading-card-wrapper pt-2">
    <!-- <a routerLink="/dashboard/crm" class="header-logo">
            <img src="./assets/images/brand-logos/logo.png" alt="logo" class="desktop-logo">
            <img src="./assets/images/brand-logos/logo.png" alt="logo" class="toggle-logo">
            <img src="./assets/images/brand-logos/logo.png" alt="logo" class="desktop-dark">
            <img src="./assets/images/brand-logos/logo.png" alt="logo" class="toggle-dark">
            <img src="./assets/images/brand-logos/logo.png" alt="logo" class="desktop-white">
            <img src="./assets/images/brand-logos/logo.png" alt="logo" class="toggle-white">
        </a> -->
    <div
      class="header-logo header-card block relative flex box-sizing-border w-[100%] md:w-full overflow-auto justify-center pt-4">
      <div class="rounded-[12px] bg-[#FFFFFF] relative flex p-[50px_14px_14px_14px] box-sizing-border w-[90%]">
        <div class="relative flex flex-col items-center justify-center box-sizing-border w-full">

          <!-- Dynamic Fields Section -->
          <div
            class="m-[0_0.4px_10px_0] inline-block self-center break-words font-['Poppins'] font-medium text-[16px] text-[#000000] text-center">

            <!-- Name and Username -->
            <div class="font-bold text-sm tracking-wide text-black">
              {{userDTO?.firstName}}, {{userDTO?.lastName}},
              <span class="!text-[#0084ff]">{{userDTO?.username}}</span>
            </div>

            <!-- Type of User and Branch Name -->
            <div class="text-xs font-medium">
              <span class="text-gray-700">{{userDTO?.typeUserName}}</span>,
              <span class="text-black">{{userDTO?.branchName}}</span>
            </div><br>

            <!-- Teller Key and Bank Account -->
            <div class="text-xs font-mediumflex flex-col gap-0">
              <div class="flex justify-between items-center">
                <span class="text-black min-w-[60px] text-left">{{'AGENT_TRANSACTIONS.TELLER' | translate}}:</span>
                <span class="text-right !text-[#089169]">{{userDTO?.tellerKey}}</span>
              </div>
              <div class="flex justify-between items-center">
                <span class="text-black min-w-[60px] text-left">{{'CUSTOMER.ACCOUNT' | translate}}:</span>
                <span class="!text-[#0084ff] text-right">{{userDTO?.agentAccountName}}</span>
              </div>
              <div class="flex justify-between items-center">
                <span class="text-black min-w-[60px] text-left">{{'SERVICES.ACCOUNT_NO' | translate}}:</span>
                <span class="!text-[#0084ff] text-right">{{userDTO?.senderId}}</span>
              </div>
            </div>

            <!-- Region and Department -->
            <div class="text-xs font-medium text-gray-700 text-left">
              <!-- Centre | {{userDTO?.regionName}} -->
              {{userDTO?.departmentName}} | {{userDTO?.regionName}}
            </div>

            <!-- Enrollment Date -->
            <!-- <div class="text-xs font-medium text-left">
              <span class="text-black mr-1">Agent since</span>
              <span class="text-gray-700">{{userDTO?.enrollmentDate | date: 'MM/dd/yyyy'}}</span>
            </div> -->

          </div>
        </div>
      </div>

      <!-- Profile Image -->
      <div class="absolute left-[50%] top-[0px] translate-x-[-50%] w-[60px] h-[60px] flex items-center justify-center">
        <img class="w-[60px] h-[60px] rounded-full object-cover" src="assets/avatardefault.jpeg" alt="Ellipse Logo" />
        <!-- <img class="w-[60px] h-[60px] rounded-full object-cover" *ngIf="userDTO.photo" [src]="userDTO.photo" alt="Profile Image" /> -->
      </div>
    </div>
    <div class="header-image hidden">
      <img class="w-[60px] h-[60px] rounded-full object-cover" src="assets/avatardefault.jpeg" alt="Ellipse Logo" />
    </div>
  </div>
  <div>
    <ngx-simplebar [options]="options" class="main-sidebar mt-0" id="sidebar-scroll">
      <nav class="main-menu-container nav nav-pills flex-column sub-open">

        <div class="slide-left" id="slide-left">
          <svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24" height="24" viewBox="0 0 24 24">
            <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"></path>
          </svg>
        </div>
        <ul class="main-menu">
          @for(menuItem of menuItems; track $index) {
            <ng-container>
              <li
                class="slide"
                #activeMenuItems
                [ngClass]="{
                  'slide__category': menuItem.headTitle,
                  'slide has-sub': menuItem.title,
                  open: menuItem.active,
                  active: menuItem.selected
                }"
              >
                <!-- head title -->
                @if(menuItem.headTitle) {
                  <span
                    class="category-name font-bold"
                    style="font-size: 13px; color: #ffffff;"
                    >{{ menuItem.headTitle | translate }}</span
                  >
                }
        
                <!-- has-Link -->
                @if(menuItem.type === 'link') {
                  <a
                    class="side-menu__item"
                    [routerLink]="!menuItem.type ? null : [menuItem.path]"
                    routerLinkActive="active"
                    (click)="setNavActive(menuItem); menuOpen()"
                  >
                    @if(menuItem.icon) {
                      <i class="side-menu__icon bx bx-{{ menuItem.icon }}"></i>
                    }
                    <span class="side-menu__label"
                      >{{ menuItem.title | translate }}
                      <span
                        class="badge !bg-{{ menuItem.badgeClass }}/10 !text-{{
                          menuItem.badgeText
                        }} !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2"
                        >{{ menuItem.badgeValue }}</span
                      >
                    </span>
                  </a>
                }
        
                <!-- has-empty -->
                @if(menuItem.type === 'empty') {
                  <a
                    class="side-menu__item"
                    href="javascript:;"
                    (click)="setNavActive(menuItem)"
                  >
                    @if(menuItem.icon) {
                      <i class="side-menu__icon bx bx-{{ menuItem.icon }}"></i>
                    }
                    <span class="side-menu__label"
                      >{{ menuItem.title | translate }}
                      <span
                        class="badge !bg-warning/10 !text-warning !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2"
                        >hot</span
                      >
                    </span>
                  </a>
                }
        
                <!-- has-Sub -->
                @if(menuItem.type === 'sub') {
                  <a
                    class="side-menu__item"
                    [routerLink]="menuItem.type ? null : [menuItem.path]"
                    [ngClass]="{ active: menuItem.selected }"
                    (click)="toggleNavActive(menuItem)"
                  >
                    @if(menuItem.icon) {
                      <i class="side-menu__icon bx bx-{{ menuItem.icon }}"></i>
                    }
                    <span class="side-menu__label"
                      >{{ menuItem.title | translate }}
                      <span
                        class="badge !bg-{{ menuItem.badgeClass }}/10 !text-{{
                          menuItem.badgeText
                        }} !py-[0.25rem] !px-[0.45rem] !text-[0.75em] ms-2"
                        >{{ menuItem.badgeValue }}</span
                      >
                    </span>
                    <i class="fe fe-chevron-right side-menu__angle"></i>
                  </a>
                }
        
                <!-- 2nd Level menu -->
                @if(menuItem.children) {
                  <ul
                    class="slide-menu child1 {{ menuItem.menutype }}"
                    [ngClass]="{ active: menuItem.active, 'double-menu-active': menuItem.active }"
                    [ngStyle]="{ display: menuItem.active ? 'block' : 'none' }"
                  >
                    <li class="slide side-menu__label1">
                      <a href="javascript:void(0)">{{ menuItem.title | translate }}</a>
                    </li>
        
                    @for(childrenItem of menuItem.children; track $index) {
                      <ng-container>
                        <li
                          class="slide"
                          activeMenuItems
                          [ngClass]="{
                            open: childrenItem.active,
                            'has-sub': childrenItem.type === 'sub'
                          }"
                        >
                          <!-- link -->
                          @if(childrenItem.type === 'link') {
                            <a
                              class="side-menu__item"
                              [routerLink]="!childrenItem.type ? null : [childrenItem.path]"
                              routerLinkActive="active"
                              [routerLinkActiveOptions]="{ exact: true }"
                              (click)="setNavActive(childrenItem)"
                            >
                              {{ childrenItem.title | translate }}
                            </a>
                          }
        
                          <!-- empty -->
                          @if(childrenItem.type === 'empty') {
                            <a
                              class="side-menu__item"
                              href="javascript:;"
                              (click)="setNavActive(childrenItem)"
                            >
                              {{ childrenItem.title | translate }}
                            </a>
                          }
        
                          <!-- sub -->
                          @if(childrenItem.type === 'sub') {
                            <a
                              class="side-menu__item"
                              [ngClass]="{ active: childrenItem.active }"
                              [routerLink]="childrenItem.type ? null : [childrenItem.path]"
                              (click)="toggleNavActive(childrenItem)"
                            >
                              <span>{{ childrenItem.title | translate }}</span>
                              <i class="fe fe-chevron-right side-menu__angle"></i>
                            </a>
                          }
        
                          <!-- 3rd Level menu -->
                          @if(childrenItem.children) {
                            <ul
                              class="slide-menu child2"
                              [ngStyle]="{
                                display: childrenItem.active ? 'block' : 'none',
                                right: localdata['ynex-dir'] == 'rtl' ? 'auto' : '',
                                left: localdata['ynex-dir'] == 'rtl' ? '100%' : ''
                              }"
                              [ngClass]="{ open: childrenItem.active }"
                            >
                              @for(childrenSubItem of childrenItem.children; track $index) {
                                <ng-container>
                                  <li
                                    class="slide"
                                    activeMenuItems
                                    [ngClass]="{ active: childrenSubItem.selected }"
                                  >
                                    <!-- link -->
                                    @if(childrenSubItem.type === 'link') { }
                                    <a
                                      class="side-menu__item"
                                      [ngClass]="{ active: childrenSubItem.selected }"
                                      routerLinkActive="active"
                                      [routerLink]="
                                        !childrenSubItem.type ? null : [childrenSubItem.path]
                                      "
                                      [routerLinkActiveOptions]="{ exact: true }"
                                    >
                                      {{ childrenSubItem.title | translate }}
                                      {{ localdata['ynex-dir'] }}
                                    </a>
        
                                    <!-- empty -->
                                    @if(childrenSubItem.type === 'empty') {
                                      <a class="side-menu__item" href="javascript:;">
                                        {{ childrenSubItem.title | translate }}
                                      </a>
                                    }
                                  </li>
                                </ng-container>
                              }
                            </ul>
                          }
                        </li>
                      </ng-container>
                    }
                  </ul>
                }
              </li>
            </ng-container>
          }
        </ul>        
        <div class="slide-right" id="slide-right"><svg xmlns="http://www.w3.org/2000/svg" fill="#7b8191" width="24"
            height="24" viewBox="0 0 24 24">
            <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path>
          </svg></div>
      </nav>
    </ngx-simplebar>
  </div>
  <div class="sticky bottom-0 border-t border-white border-opacity-10">
    <ul class="main-menu">
      <li class="slide cursor-pointer">
        <a class="side-menu__item flex justify-center" (click)="onLogoutClick()">
          <i class="side-menu__icon  bx bx-log-out"></i>
          <span class="side-menu__label">Logout</span>
        </a>
      </li>
    </ul>
  </div>

</aside>
